import { formatToAspectRatioNum } from '../utility'
import {
    FormatDateTimeEntryToLocaleString,
    validityDateUTCToJsDate
} from '../../utils/date';

export default class TemplateService {

    async getTemplates(loadPast = true, loadFuture = true) {
        const response = await axios.post('/content/template/get', {
            id: Laravel.activeProject,
            //keyword: this.search_template,
            //tags: this.tag_template,
            model: true,
            //ignore: this.ignoreType === 'template' ? this.ignoreId : null,
            show_past: loadPast,
            show_future: loadFuture
            //keyword: 'text'
        })

        //console.log('templateService {...res.data}', {...res.data})

        // Create temporary fields, for use with PrimeVue DataTable
        response.data.data.forEach((dataEntry => {
            //dataEntry.screen_info = {
            //    resolution: dataEntry.parameters.resolution,
            //    format: dataEntry.parameters.format
            //}
            dataEntry.screen_info = `${dataEntry.parameters.resolution} | ${dataEntry.parameters.format}`
            dataEntry.parameters.aspectRatio = formatToAspectRatioNum(dataEntry.parameters.format)

            //dataEntry.validity = {
            //    status: dataEntry.parameters['validity-status'],
            //    text: dataEntry.parameters['validity-text']
            //}

            // 'validity-text' date is localised
            dataEntry.validity_text = dataEntry.parameters['validity-text']
            // 'valid-from' and 'valid-to' are not localised (passed in American US format)
            dataEntry.valid_from_millis = new Date(dataEntry.parameters['valid-from']).getTime()

            // 'created_at' and 'updated_at' are localised AND in UTC
            dataEntry.created_at_millis = validityDateUTCToJsDate(dataEntry.created_at).getTime()
            dataEntry.created_at_local = FormatDateTimeEntryToLocaleString(dataEntry.created_at_millis)
            dataEntry.updated_at_millis = validityDateUTCToJsDate(dataEntry.updated_at).getTime()
            dataEntry.updated_at_local = FormatDateTimeEntryToLocaleString(dataEntry.updated_at_millis)

            //console.log('dataEntry', dataEntry)

            // Randomly add '§hidden' tag to entries, meant for debug
            /*if(Math.random() > 0.7) {
                dataEntry.tags.push({name: '§hidden'})
            }*/

        }))

        // 'slice' here creates a new shallow array copy, which is then sorted to get indices in the correct order.
        // The original array is unmodified, but it does contain references to the same entries, so modifying the
        // entries' props here will also result in them being modified in the original array.
        response.data.data.slice()
            .sort((a, b) => a.name.localeCompare(b.name, Laravel.activeLanguage))
            .forEach((dataEntry, index) => dataEntry.name_sortable = index)

        //await new Promise(r => setTimeout(r, 2000));

        return response.data //{data: [], editPrivilege: 1}

    }
}
